// extracted by mini-css-extract-plugin
export var categoryIcon = "_dc-5";
export var connectorContainer = "_dc-1";
export var connectorLine = "_dc-0";
export var minHeight0 = "_dc-6";
export var relativeUnitValueSelector = "_dc-2";
export var trifoldSelectorBody = "_dc-4";
export var trifoldSelectorList = "_dc-3";